import React, { useState } from "react";
import "./HamburgerMenu.css"; // CSS for styling the menu

function HamburgerMenu({ setView, handleLogout }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuClick = (view) => {
    setView(view);
    toggleMenu();
  };

  return (
    <div className="hamburger-container">
      {/* Hamburger Icon */}
      <button className="hamburger-icon" onClick={toggleMenu}>
        ☰
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="hamburger-menu">
          <button className="menu-item" onClick={() => handleMenuClick("notes")}>
            My Notes
          </button>
          <button className="menu-item" onClick={() => handleMenuClick("shared-notes")}>
            Shared Notes
          </button>
          <button className="menu-item" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default HamburgerMenu;